export const APP_FIELD_THEME_CLASS =
  'border-input bg-background text-foreground placeholder:text-muted-foreground';

export const APP_NATIVE_FIELD_CLASS =
  'rounded-lg border border-input bg-background px-3 py-2 text-foreground placeholder:text-muted-foreground shadow-sm focus:outline-none focus:ring-2 focus:ring-ring';

export const APP_FILTER_LABEL_CLASS =
  'block text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground';
